import { type FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowRight, SpinnerGap } from '../components/ui/icons'
import { api } from '../lib/api'
import { Button, Input } from '../components/ui/primitives'

export function EntryPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      const result = await api.findWorkspace(email)
      if (result.kind === 'admin') {
        window.location.assign(result.redirectTo)
        return
      }
      const state = { email: email.trim().toLowerCase(), codeRequested: true }
      navigate(result.kind === 'partner' ? `/partner/${result.slug}` : `/${result.slug}`, { state })
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'We could not find your workspace.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="access-page entry-page">
      <section className="access-brand">
        <img src="/prentus-logo-white.png" alt="Prentus" className="prentus-wordmark" />
        <div>
          <p>Your partnership, in one place.</p>
          <h1>Shared resources, next steps, and results for your team</h1>
        </div>
      </section>
      <section className="access-form-wrap">
        <form className="access-form" onSubmit={submit}>
          <h2>Open your workspace</h2>
          <p>Enter your work email. We will send customers to their shared workspace, partners to their partner area, and Prentus team members to sign in.</p>
          <label>
            <span>Work email</span>
            <Input
              type="email"
              autoComplete="email"
              value={email}
              placeholder="you@organization.edu"
              onChange={(event) => setEmail(event.target.value)}
              autoFocus
            />
          </label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <Button full disabled={busy || !email.trim()}>
            {busy ? <SpinnerGap size={18} className="spin" /> : <ArrowRight size={18} />}
            Continue
          </Button>
        </form>
      </section>
    </main>
  )
}
